import { createContext } from 'react';

import useProvideAuth from './UseProvideAuth';

export type AuthContextValue = ReturnType<typeof useProvideAuth>;

const AuthContext = createContext<AuthContextValue | null>(null);

export default AuthContext;
